import { Box, Button, Divider, Sheet } from "@mui/joy";
import { DialogContent, DialogTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { formOpenSelector, setFormOpen } from "../../reducers/rhapsody";
import DialogClose from "../dialogClose/dialogClose";
import { useLocalStorage } from "@uidotdev/usehooks";
import {
  DialogHeader,
  FieldLabel,
  GroupCaption,
  dialogPaperSx,
  groupSheetSx,
  tileColors,
} from "../formKit/formKit";
/**
 *
 * @returns {ReactElement} WeeksStartOn page
 */
export function WeeksStartOn() {
  const open = useSelector(formOpenSelector("weeksStartOn"));
  const dispatch = useDispatch();
  const [week, setWeek] = useLocalStorage("WeeksStartOn", "0");

  const onClose = () => {
    dispatch(setFormOpen({ formID: "weeksStartOn", isOpen: false }));
  };

  return (
    <DialogClose
      open={open}
      onClose={onClose}
      PaperProps={{ sx: dialogPaperSx }}
    >
      <DialogTitle>
        <DialogHeader
          title="Weeks start on"
          subtitle="Select your preference for the first day of the week"
        />
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          width: 400,
          maxWidth: "100%",
        }}
      >
        <GroupCaption>First day of the week</GroupCaption>
        <Sheet variant="soft" sx={groupSheetSx}>
          <Button
            fullWidth
            onClick={() => {
              setWeek("0");
              onClose();
            }}
            variant="plain"
            color="neutral"
            sx={{ borderRadius: 0, px: 1.5, py: 1.25, fontWeight: 500 }}
            startDecorator={
              <FieldLabel
                icon="fa-solid fa-calendar-days"
                color={tileColors.red}
              />
            }
            endDecorator={
              week === "0" ? (
                <i
                  className="fa-solid fa-check"
                  style={{ color: tileColors.blue }}
                ></i>
              ) : undefined
            }
          >
            <Box sx={{ flexGrow: 1, textAlign: "left" }}>Sunday</Box>
          </Button>
          <Divider />
          <Button
            fullWidth
            onClick={() => {
              setWeek("1");
              onClose();
            }}
            variant="plain"
            color="neutral"
            sx={{ borderRadius: 0, px: 1.5, py: 1.25, fontWeight: 500 }}
            startDecorator={
              <FieldLabel
                icon="fa-solid fa-calendar-days"
                color={tileColors.red}
              />
            }
            endDecorator={
              week === "1" ? (
                <i
                  className="fa-solid fa-check"
                  style={{ color: tileColors.blue }}
                ></i>
              ) : undefined
            }
          >
            <Box sx={{ flexGrow: 1, textAlign: "left" }}>Monday</Box>
          </Button>
        </Sheet>
      </DialogContent>
    </DialogClose>
  );
}
